<div class="w-full flex justify-end" *ngIf="matchingParcel && _showComparison">
	<div class="w-auto rounded-xl p-1 px-2 bg-grey-lighter text-sm">
		<app-icon [icon]="ICON.CHECK" class="mr-2"></app-icon>
		Synced
	</div>
</div>
<div class="grid grid-cols-3 gap-y-4">
	<mat-form-field class="mx-5" class="w-full px-5 col-start-1">
		<input
			matInput
			[(ngModel)]="originalPin.pin"
			placeholder="Pin"
			required
			type="text"
			[disabled]="true"
		/>
	</mat-form-field>

	<div
		class="col-start-3 border-l border-grey-lighter pl-3"
		[class.hidden]="!_showComparison"
	>
		<app-input
			class=""
			label="PIN"
			[(ngModel)]="parcel.pinNumber"
			(onBlur)="updateParcel()"
			disabled
		></app-input>
	</div>

	<mat-form-field class="mx-5" class="w-full px-5 col-start-1">
		<input
			matInput
			[(ngModel)]="originalPin.legal_desc"
			placeholder="Description"
			required
			type="text"
			[disabled]="true"
		/>
	</mat-form-field>

	<div class="flex justify-center items-start w-full col-start-2">
		<button
			type="button"
			(click)="toggleComparison()"
			mat-stroked-button
			[ngClass]="{ 'bg-green-300': _showComparison }"
			class="flex justify-center items-center"
		>
			<app-icon [icon]="ICON.ARROW_RIGHT"></app-icon>
		</button>
	</div>

	<div
		class="grid grid-cols-2 gap-1 border-l border-grey-lighter pl-3"
		[class.hidden]="!_showComparison"
	>
		<app-text-area
			class="col-span-2"
			label="Description"
			[(ngModel)]="parcel.legalDescription"
			(onBlur)="updateParcel()"
		></app-text-area>
		<app-input
			label="Lot"
			[(ngModel)]="parcel.lot"
			(onBlur)="updateParcel()"
		></app-input>
		<app-input
			label="Plan"
			[(ngModel)]="parcel.planName"
			(onBlur)="updateParcel()"
		></app-input>
	</div>

	<mat-form-field class="w-full px-5 col-start-1">
		<input
			matInput
			[(ngModel)]="latestInstrument"
			placeholder="Latest Instrument"
			required
			type="text"
			[disabled]="true"
		/>
	</mat-form-field>

	<div
		class="border-l border-grey-lighter pl-3 col-start-3"
		[class.hidden]="!_showComparison"
	>
		<app-input
			class=""
			label="Latest Instrument"
			[(ngModel)]="parcel.latestInstrument"
			(onBlur)="updateParcel()"
		></app-input>
	</div>
</div>
